/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContemporaryLandingVideoModule_contemporaryLandingVideo$ref: FragmentReference;
export type ContemporaryLandingVideoModule_contemporaryLandingVideo = {|
  +cta: ?string,
  +description: ?string,
  +embedId: ?string,
  +subtitle: ?string,
  +title: ?string,
  +url: ?string,
  +$refType: ContemporaryLandingVideoModule_contemporaryLandingVideo$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ContemporaryLandingVideoModule_contemporaryLandingVideo",
  "type": "ContemporaryLandingVideo",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "cta",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "embedId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "subtitle",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "url",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '2d38ea910e7da17d8a74fe35c43eed41';
module.exports = node;
